import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "root"
};
const _hoisted_2 = {
  class: "content"
};
import AppFooter from "./components/app-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import ruMessages from "devextreme/localization/messages/ru.json";
import { locale, loadMessages } from "devextreme/localization";
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const securityStore = useSecurityStore();
    const rerenderKey = ref(0);
    loadMessages(ruMessages);
    locale("ru");
    watch(() => securityStore.selectedTaxiDepots, () => {
      if (securityStore.selectedTaxiDepots.length > 0) rerenderKey.value++;
    }, {
      immediate: false
    });
    function getScreenSizeInfo() {
      const screenSizes = sizes();
      return {
        isXSmall: screenSizes["screen-x-small"],
        isLarge: screenSizes["screen-large"],
        cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
      };
    }
    const screen = reactive({
      getScreenSizeInfo: {}
    });
    screen.getScreenSizeInfo = getScreenSizeInfo();
    function screenSizeChanged() {
      screen.getScreenSizeInfo = getScreenSizeInfo();
    }
    onMounted(() => {
      subscribe(screenSizeChanged);
    });
    onBeforeUnmount(() => {
      unsubscribe(screenSizeChanged);
    });
    const cssClasses = computed(() => {
      return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(_unref(cssClasses))
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout), {
        title: _unref(route).meta.title,
        "is-x-small": _unref(screen).getScreenSizeInfo.isXSmall,
        "is-large": _unref(screen).getScreenSizeInfo.isLarge
      }, {
        footer: _withCtx(() => [_createVNode(_unref(AppFooter))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_component_router_view, {
          key: _unref(rerenderKey)
        }))])]),
        _: 1
      }, 8, ["title", "is-x-small", "is-large"]))], 2)]);
    };
  }
};